import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useT } from "@/i18n/LanguageContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { t } = useT();
  const loc = useLocation();
  if (loading || user === null) {
    return (
      <div className="min-h-[60vh] grid place-items-center text-white/50" data-testid="protected-loading">
        {t.protected?.loading || t.auth?.verifying || "Verifying session…"}
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  return children;
};

export default ProtectedRoute;
